import { Outlet, Navigate } from 'react-router-dom'
import { useAuthStatus } from '../store/selectors/userSelector'
import { URLS } from '.'

const PublicRoutes = () => {
    const isAuth = useAuthStatus()
    console.log('MSAL Event :  PublicRoutes - isAuth: public', isAuth)
    return isAuth ? <Navigate data-testid="navigate" to={URLS.MY_EXPERIMENTS} /> : <Outlet />
}

export default PublicRoutes
